import { createFileRoute } from '@tanstack/react-router'
import PricingPage from '@/pages/pricing'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/pricing')({
  beforeLoad: ({ params }) =>
    redirectIfPublicPageHidden('pricing', params.lang),
  head: ({ params }) => buildHead('pricing', params.lang),
  component: PricingPage,
  staticData: { layout: 'public' },
})
